import DisclosureButton from './DisclosureButton'
import DisclosureContent from './DisclosureContent'

export default {
  DisclosureButton,
  DisclosureContent,
}



// WEBPACK FOOTER //
// ./src/js/components/disclosure/index.js